import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const RoninLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M3.43 1.846v14.807a1.84 1.84 0 0 0 .695 1.44l7.008 5.603a1.393 1.393 0 0 0 1.737 0l7.008-5.603a1.847 1.847 0 0 0 .695-1.44V1.846c0-.49-.195-.959-.543-1.305A1.857 1.857 0 0 0 18.72 0H5.283c-.491 0-.963.195-1.31.54a1.843 1.843 0 0 0-.543 1.306ZM15.4 3.714c.423 0 .83.17 1.13.473.3.302.469.713.469 1.14v3.228c0 .427-.169.837-.468 1.14-.3.302-.705.473-1.129.473.424 0 .831.17 1.131.473.3.303.469.713.469 1.141v2.91a1.625 1.625 0 0 1-.6 1.258l-2.476 2.005a.198.198 0 0 1-.294-.05.203.203 0 0 1-.03-.107v-5.613c0-.32-.127-.628-.352-.855a1.194 1.194 0 0 0-.848-.355h-1.8a.2.2 0 0 0-.2.202v6.62a.203.203 0 0 1-.113.183.198.198 0 0 1-.212-.025L7.6 15.95a1.611 1.611 0 0 1-.6-1.259V5.328c0-.428.17-.839.469-1.141.3-.303.707-.473 1.131-.473Zm-2 1.614h-2.8a.2.2 0 0 0-.14.059.203.203 0 0 0-.06.142V9.16c0 .054.022.105.06.143a.2.2 0 0 0 .14.059h1.8c.318 0 .623-.128.848-.355.225-.227.352-.535.352-.855V5.529a.203.203 0 0 0-.059-.142.199.199 0 0 0-.141-.06Z" fill={fillAttribute} />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};